<template>
    <div class="weeks">
        <template
            v-if="mode === 'dayListPlanning'"
        >
            <top-row-day-list-planning-component
                v-for="(week, index) in weeks"
                :key="index"
                :week="week"
                :calendar-width="calendarWidth"
                :current-zoom="currentZoom"
            ></top-row-day-list-planning-component>
        </template>
        <template
            v-else-if="mode === 'dailyPlanned'"
        >
            <top-row-daily-planned-component
                v-for="(date, index) in dates"
                :key="index"
                :date="date"
            ></top-row-daily-planned-component>
        </template>
        <template
            v-else-if="mode === 'teamLead'"
        >
            <top-row-team-lead-component
                v-for="(date, index) in dates"
                :key="index"
                :date="date"
            ></top-row-team-lead-component>
        </template>
        <template
            v-else-if="currentZoom > 0"
        >
            <top-row-week
                v-for="(week, index) in weeks"
                :key="index"
                :week="week"
            ></top-row-week>
        </template>
        <template
            v-else-if="currentZoom === 0"
        >
            <top-row-day-component
                v-for="(date, index) in dates"
                :key="index"
                :date="date"
            ></top-row-day-component>
        </template>

    </div>
</template>

<script>
import { mapState } from 'vuex';
import topRowWeek from './TopRowWeekComponent.vue';
import TopRowDayComponent from './TopRowDayComponent';
import TopRowDailyPlannedComponent from "./TopRowDailyPlannedComponent.vue";
import TopRowDayListPlanningComponent from "./TopRowDayListPlanningComponent.vue";
import TopRowTeamLeadComponent from "./TopRowTeamLeadComponent.vue";

export default {
    components: {
        TopRowDailyPlannedComponent,
        TopRowDayListPlanningComponent,
        TopRowTeamLeadComponent,
        topRowWeek,
        TopRowDayComponent,
    },
    props: {
        calendarWidth: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapState('planning', ['dateStart', 'dateEnd', 'currentZoom', 'dates','mode']),
        weeks() {
            let dateStart = this.dateStart;
            let dateEnd = this.dateEnd;
            if (!dateStart || !dateEnd) return;

            let weeks = [];

            // Day view for dayListPlanning: return individual days, not weeks
            if (this.mode === 'dayListPlanning' && this.currentZoom === 0) {
                while (dateStart.isBefore(dateEnd) || dateStart.equals(dateEnd)) {
                    weeks.push(dateStart);
                    dateStart = dateStart.plusDays(1);
                }
                return weeks;
            }

            // Week and month view: iterate by weeks
            while (dateStart.isBefore(dateEnd)) {
                weeks.push(dateStart);
                dateStart = dateStart.plusWeeks(1);
            }
            return weeks;
        },
    },
};
</script>

<style lang="scss">
.weeks {
    display: inline-flex;
}
</style>
